import Vue from "vue";
import { gameStore } from "../store/game/store";
import {
  ActionMode,
  Action,
  CategoryQuestion,
  ColorQuestion,
  CardCategory,
  Colors
} from "@/store/game";
import { Client } from "../client";
import _ from 'lodash';
export default Vue.extend({
  data() {
    return {
      questionColor: undefined as undefined | number,
      questionCategory: undefined as undefined | string,
      accordion: ""
    };
  },
  computed: {
    visible() {
      return gameStore.state.ui.showChooseQuestionDlg;
    },
    colors() {
      return Colors;
    },
    choiceMade(): boolean {
      return (
        this.questionColor != undefined || this.questionCategory != undefined
      );
    },
    witness() {
      return _.find(gameStore.state.players, p => p.id == gameStore.state.ui.witnessId)?.name;
    }
  },
  methods: {
    getWitnessInfo() {
      let question = {} as CategoryQuestion | ColorQuestion;
      if (this.questionColor != undefined) {
        (<ColorQuestion>question).color = this.questionColor;
      }
      if (this.questionCategory) {
        const questionParts = this.questionCategory.split("_");
        (<CategoryQuestion>question).category = <CardCategory>questionParts[0];
        (<CategoryQuestion>question).type = <"A" | "B">questionParts[1];
      }

      Client.getInstance().send({
        action: Action.getWitnessInfo,
        witnessId: gameStore.state.ui.witnessId,
        question
      });
      this.dismiss();
    },
    dismiss() {
      this.questionCategory = undefined;
      this.questionColor = undefined;
      this.accordion = "";
      gameStore.commitToggleChooseQuestionDlg({ show: false });
    },
    panelChanged() {
      this.questionCategory = undefined;
      this.questionColor = undefined;
    }
  },
  watch: {
    questionColor(val) {
      if (val != undefined) this.questionCategory = undefined;
    },
    questionCategory(val) {
      if (val) this.questionColor = undefined;
    }
  }
});